import React from 'react';
import { useTranslations } from 'next-intl';
import { LightningBlack } from 'assets/icons/LightningBlack';
import type { LeaderboardEntry } from './types';
import styles from './LeaderboardCard.module.css';

type LeaderboardCardProps = {
  entry: LeaderboardEntry;
};

const PODIUM_MAX_RANK = 3;

export const LeaderboardCard: React.FC<LeaderboardCardProps> = ({ entry }) => {
  const t = useTranslations('performance-lab');
  const isLeader = entry.rank === 1;
  const isPodium = entry.rank <= PODIUM_MAX_RANK;
  const showLightning = isPodium && entry.name != null;
  const empty = t('leaderboard.emptyValue');
  const displayName = entry.name ?? empty;
  const displayScore =
    entry.score != null ? entry.score.toFixed(1) : empty;

  return (
    <li
      className={styles.card}
      data-is-leader={isLeader}
      data-is-podium={isPodium}
    >
      <div className={styles.left}>
        <span className={styles.rank} aria-hidden="true">
          {String(entry.rank).padStart(2, '0')}
        </span>
        <div className={styles.nameGroup}>
          <div className={styles.nameLine}>
            <span className={styles.name}>{displayName}</span>
            {entry.tag != null ? (
              <>
                <span className={styles.tagSeparator} aria-hidden="true">
                  /
                </span>
                <span className={styles.nameTagSuffix}>{entry.tag}</span>
              </>
            ) : null}
          </div>
          {isLeader ? (
            <span className={styles.leaderBadge}>
              {t('leaderboard.leaderBadge')}
            </span>
          ) : null}
        </div>
      </div>
      <div className={styles.scoreGroup}>
        <span className={styles.iconSlot} aria-hidden="true">
          {showLightning ? (
            <LightningBlack fill="#EAB308" />
          ) : null}
        </span>
        <span className={styles.score}>
          {displayScore}
        </span>
      </div>
    </li>
  );
};
